export default "__VITE_ASSET__FtMPRP9G__"